exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5fa30ff5] .v-input.custom_select.v-text-field.v-text-field--enclosed{border:1px solid var(--gray-300,#d1d5db);border-radius:6px;padding:1px}", ""]);

// exports
